import { TAnswerState } from '../../../../containers/FormContainer/types/internal';
import { TAddressField, TGeoField } from '../../../../containers/FormContainer/types';
import { flatten } from 'ramda';
import { IGeoValue } from '../../../../containers/GeoContainer/types';
import { ESuggestType } from '@cian/geosuggest-widget';
import { IGeoResultValue } from '../../types';

export const _getGeoObject = (override?: Partial<IGeoResultValue>): IGeoResultValue => ({
  address: null,
  districtIds: [],
  houseIds: [],
  locationIds: [],
  highwayIds: [],
  streets: [],
  undergroundIds: [],
  ...override,
});

export const _addGeoItemId = (item: IGeoValue, geoObject: IGeoResultValue) => {
  if (item.id === undefined) {
    return;
  }

  switch (item.group) {
    case ESuggestType.city:
      geoObject.locationIds.push(item.id);
      break;
    case ESuggestType.road:
      geoObject.highwayIds.push(item.id);
      break;
    case ESuggestType.district:
      geoObject.districtIds.push(item.id);
      break;
    case ESuggestType.underground:
      geoObject.undergroundIds.push(item.id);
      break;
  }
};

export const addressMapper = (answerState: TAnswerState) => {
  const value = answerState.value as TAddressField;

  if (!value?.address) {
    return {
      geo: _getGeoObject(),
    };
  }

  return {
    geo: _getGeoObject({
      address: value.address,
      houseIds: [value.houseId],
      locationIds: [value.locationId],
    }),
  };
};

export const geoMapper = (answerState: TAnswerState) => {
  const value = answerState.value as TGeoField;

  if (!value?.location) {
    return {
      geo: _getGeoObject(),
    };
  }

  const geo = _getGeoObject({
    locationIds: [value.location.id],
  });

  if (value.geoValues) {
    const items = flatten(Object.values(value.geoValues)) as IGeoValue[];
    for (const item of items) {
      /** Для улиц мы передаем массив адресов
       * Улицы из API Yandex возвращаются с типом geo
       * */
      if (item.group === ESuggestType.geo) {
        geo.streets.push(item.title);

        continue;
      }

      /** Для всего остального id */
      _addGeoItemId(item, geo);
    }
  }

  return { geo };
};
